<template>

<div>
            <div class="col-lg-12"> 
              <div class="container">

                <div class=" w-100 h-100 p-5 mx-auto text-center">
                  <h1 class="titulo-cambio">¿Como hacer un <span> CAMBIO</span>?</h1>
                  <h4 class="sub-ttulo text-center">3 pasos simples para realizar tu cambio</h4>
                </div>

                <div class="row  w-100 h-100 p-5">
                    <div class="col-md-4 d-flex pt-3">
                        <img class="flex-shrink-0 me-2" src="@/assets/img/movil.png" alt="" width="80">
                        <p class="numero flex-shrink-0 me-2">1</p>
                            <p class="pb-3 mb-0 small lh-sm p-3">
                                Registra <br>
                                tu operación
                            </p>     
                    </div>
                    <div class="col-md-4 d-flex pt-3">
                        <img class="flex-shrink-0 me-2" src="@/assets/img/transferencia.png" alt="" width="80">
                        <p class="numero flex-shrink-0 me-2">2</p>
                            <p class="pb-3 mb-0 small lh-sm p-3">
                                Registra <br>
                                tu operación
                            </p>
                    </div>
                    <div class="col-md-4 d-flex pt-3">
                        <img class="flex-shrink-0 me-2" src="@/assets/img/cambio.png" alt="" width="80">
                        <p class="numero flex-shrink-0 me-2">3</p>
                            <p class="pb-3 mb-0 small lh-sm p-3">
                                Registra <br>
                                tu operación
                            </p>
                    </div>
                </div>

                <div class="video  w-100 h-100 p-5 text-center">
                  <!--<script type="application/javascript" src="https://www.youtube.com/iframe_api"></script>--> 
                        <div text-align="center" class="mm-product-video-modal-container">
                            <div class="mm-product-video-modal dropper">
                                <div class="embed-responsive embed-responsive-16by9">
                                    <div id="video-placeholder"></div>
                                </div>
                            </div>
                            <div class="mm-video-overlay"></div>
                        </div>
                    <a class="mm-launch"><img src="@/assets/img/play-button.svg" alt="" width="80"></a>
                </div>
                
            </div>
          </div>

          <div class="col-lg-12 fondo-black p-5">
             <div class="container">
                <div class=" w-100 h-100 p-5 mx-auto text-center">
                    <h1 class="">¿Porque usar <span> KALLPA</span>?</h1>
                  </div>
                <div class="row">
                    <div class="col-md-6">
                        <p class="texto-justify p-q">
                            KALLPA CAMBIOS es una unidad de negocio <br>de KALLPA SAB que Proveer soluciones eficientes <br>a tus necesidades de cambio de moneda <br>y/o  Solucionar eficientemente tus necesidades <br>de cambio  de moneda
                        </p>
                    </div>
                    <div class="col-md-6 ">
                        <img class="d-flex me-auto" src="img/component.png" alt="" width="350">
                    </div>
              </div>
             </div> 
          </div>

          <div class="col-lg-12 p-5">
            <div class="container">
               <div class="row">
                   <div class="col-md-6 descargar-app">
                       <h1 class="text-green">
                        Descarga nuestra <span> App </span> </h1>
                        <h1 class="text-black">realiza tus <span>cambios</span>
                        desde<br> cualquier <span>parte</span></h1>

                        <div class="d-flex pt-3">
                            <a class="flex-shrink-0 me-2"><img src="@/assets/img/android.png" alt="" width="200"></a>
                            <a class="pb-3 mb-0 lh-sm "><img src="@/assets/img/ios.png" alt="" width="200"></a>
                         </div>
                   </div>
                   <div class="col-md-6">
                      <img class="d-flex me-auto" src="@/assets/img/fotos.png" alt="" width="600">
                   </div>
             </div>
            </div> 
         </div>

    </div>
</template>
<script>
import helpers from "@/services/helpers";

export default {
  name: "Menu",

mounted(){
    jQuery('.mm-video-overlay').on('click', function() {
  destroyVideo();
});

jQuery('.mm-launch').on('click',function() {
  deployVideo();
});
},

methods:{

 onYouTubeIframeAPIReady() {
  player = new YT.Player('video-placeholder', {
    width: 640,
    height: 360,
    videoId: 'HdzI-191xhU',
    events: {
      onReady: initialize
    }
  });
},
onYouTubeIframeAPIReady() {
  player = new YT.Player('video-placeholder', {
    width: 640,
    height: 360,
    videoId: 'HdzI-191xhU',
    events: {
      onReady: initialize
    }
  });
},
initialize(){

},            

deployVideo() {
  jQuery('.mm-product-video-modal-container').addClass('open');
  setTimeout(function() {
    jQuery('.mm-product-video-modal').addClass('open');
    player.playVideo();
  }, 250);
},

destroyVideo() {
  jQuery('.mm-product-video-modal').removeClass('open');
  setTimeout(function() {
    jQuery('.mm-product-video-modal-container').removeClass('open');
    player.pauseVideo();
  }, 250);
},



  },
};
</script>





// WEBPACK FOOTER //
// src/components/pages/Inicio.vue